export const HOTEL_AUTOCOMPLETE_MIN_QUERY_LENGTH = 2;
export const HOTEL_AUTOCOMPLETE_SECTION_FULL_LIMIT = 4;
export const HOTEL_AUTOCOMPLETE_SECTION_PREVIEW_COUNT = 3;
export const HOTEL_AUTOCOMPLETE_LOAD_MORE_LABEL = 'Load more';

export const HOTEL_SEARCH_ICON_COLOR = {
  CITY: '#2563EB',
  HOTEL: '#BE123C',
  LOCATION: '#E11D48',
};

export const HOTEL_LOCATION_TYPE_COLORS = {
  AIRPORT: '#0284C7',
  RAILWAY_STATION: '#1D4ED8',
  METRO_STATION: '#0F766E',
  BUS_TERMINAL: '#EA580C',
  HOSPITAL: '#DC2626',
  MALL: '#DB2777',
  BEACH: '#0891B2',
  TOURIST_ATTRACTION: '#D97706',
  RELIGIOUS_PLACE: '#7C3AED',
  MARKET: '#16A34A',
  AREA: '#059669',
  LANDMARK: '#CA8A04',
  BUSINESS_DISTRICT: '#4F46E5',
  UNIVERSITY: '#4338CA',
  CITY: '#2563EB',
  HOTEL: '#BE123C',
  COUNTRY: '#0E7490',
  REGION: '#0F766E',
  LOCATION: '#E11D48',
};

export const HOTEL_LOCATION_TYPE_DEFAULT_LABEL = 'Location';
export const HOTEL_LOCATION_TYPE_LABELS = {
  AIRPORT: 'Airport',
  RAILWAY_STATION: 'Railway Station',
  METRO_STATION: 'Metro',
  BUS_TERMINAL: 'Bus Station',
  HOSPITAL: 'Hospital',
  MALL: 'Mall',
  BEACH: 'Beach',
  TOURIST_ATTRACTION: 'Attraction',
  RELIGIOUS_PLACE: 'Religious Place',
  MARKET: 'Market',
  AREA: 'Area',
  LANDMARK: 'Landmark',
  BUSINESS_DISTRICT: 'Business',
  UNIVERSITY: 'University',
  CITY: 'City',
  LOCATION: 'Location',
  HOTEL: 'Hotel',
  COUNTRY: 'Country',
  REGION: 'Region',
};
export const HOTEL_AUTOCOMPLETE_EMPTY_FALLBACK_QUERY = '';

export const HOTEL_AUTOCOMPLETE_BUCKET = {
  CITY: 'city',
  HOTEL: 'hotel',
  LOCATION: 'location',
  COUNTRY: 'country',
};

export const HOTEL_AUTOCOMPLETE_ITEM_TYPE = {
  CITY: 'city',
  HOTEL: 'hotel',
};

export const HOTEL_AUTOCOMPLETE_QUERY_TYPE = {
  CITY: 'city',
  HOTEL: 'hotel',
  LOCATION: 'location',
};

export const HOTEL_AUTOCOMPLETE_SECTION_ORDER = {
  [HOTEL_AUTOCOMPLETE_QUERY_TYPE.CITY]: [
    HOTEL_AUTOCOMPLETE_BUCKET.CITY,
    HOTEL_AUTOCOMPLETE_BUCKET.HOTEL,
    HOTEL_AUTOCOMPLETE_BUCKET.LOCATION,
  ],
  [HOTEL_AUTOCOMPLETE_QUERY_TYPE.HOTEL]: [
    HOTEL_AUTOCOMPLETE_BUCKET.HOTEL,
    HOTEL_AUTOCOMPLETE_BUCKET.CITY,
    HOTEL_AUTOCOMPLETE_BUCKET.LOCATION,
  ],
  [HOTEL_AUTOCOMPLETE_QUERY_TYPE.LOCATION]: [
    HOTEL_AUTOCOMPLETE_BUCKET.CITY,
    HOTEL_AUTOCOMPLETE_BUCKET.LOCATION,
    HOTEL_AUTOCOMPLETE_BUCKET.HOTEL,
  ],
};

export const HOTEL_SEARCH_AUTOCOMPLETE_PATH = '/hotels/tbo/search-autocomplete';

/** Fixed destination dropdown width. Result text must not resize the panel. */
export const HOTEL_INLINE_SEARCH_DROPDOWN_WIDTH = '340px';

export const HOTEL_MATCH_REASON = {
  EXACT: 'exact',
  TOP: 'top',
  FUZZY: 'fuzzy',
};
export const HOTEL_SEARCH_NEARBY_LOCATION_PATH = '/hotels/tbo/nearby-location';
export const HOTEL_SEARCH_BY_CITY_CODE_FIELD = 'searchByCityCode';

export const HOTEL_OUTSIDE_INVENTORY_PAGE_MESSAGE =
  "This property isn't currently listed on YovoTrip. Here are some other stays you might like in the area.";
export const HOTEL_OUTSIDE_INVENTORY_PAGE_MESSAGE_WITH_NAME =
  "{hotelName} — This property isn't currently listed on YovoTrip. Here are some other stays you might like in the area.";

export const HOTEL_NEARBY_LOCATION_LABEL = 'Find properties near me';
export const HOTEL_NEARBY_LOCATION_SUBTITLE = 'Use your current location';
export const HOTEL_NEARBY_LOCATION_LOADING = 'Finding your location...';
export const HOTEL_NEARBY_LOCATION_ERROR = 'Could not access your location. Please allow location access and try again.';
export const HOTEL_CURRENT_LOCATION_DISPLAY_NAME = 'Current location';

export const GEOLOCATION_REQUEST_OPTIONS = {
  enableHighAccuracy: true,
  timeout: 10000,
  maximumAge: 0,
};

export const HOTEL_SEARCH_INTENT_ACTION = {
  AUTO_SELECT: 'AUTO_SELECT',
  SHOW_DROPDOWN: 'SHOW_DROPDOWN',
  NO_MATCH: 'NO_MATCH',
  API_ERROR: 'API_ERROR',
};

export const HOTEL_SEARCH_SORT = {
  DISTANCE: 'Distance',
  RECOMMENDED: 'Recommended',
  PRICE_LOW: 'PriceLow',
  PRICE_HIGH: 'PriceHigh',
  STAR_RATING: 'StarRating',
  FREE_CANCELLATION: 'FreeCancellation',
  BREAKFAST_FIRST: 'BreakfastFirst',
};

export const HOTEL_SEARCH_SORT_OPTIONS = [
  { value: HOTEL_SEARCH_SORT.DISTANCE, label: 'Distance: Nearest first' },
  { value: HOTEL_SEARCH_SORT.RECOMMENDED, label: 'Recommended' },
  { value: HOTEL_SEARCH_SORT.PRICE_LOW, label: 'Price: Low to High' },
  { value: HOTEL_SEARCH_SORT.PRICE_HIGH, label: 'Price: High to Low' },
  { value: HOTEL_SEARCH_SORT.STAR_RATING, label: 'Star Rating' },
  { value: HOTEL_SEARCH_SORT.FREE_CANCELLATION, label: 'Free cancellation first' },
  { value: HOTEL_SEARCH_SORT.BREAKFAST_FIRST, label: 'Breakfast first' },
];

export const HOTEL_SEARCH_DEFAULT_SORT = HOTEL_SEARCH_SORT.DISTANCE;
